import LayoutWithSidebar from "../components/LayoutWithSidebar";
import MainHeaderContainer from "../containers/MainHeaderContainer";
import PermitsListContainer from "../containers/PermitsListContainer";

const ViewPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <></>;
  };

  const contentPanelContent = () => {
    return <PermitsListContainer></PermitsListContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default ViewPage;
